import appConfig from '@nerdwallet/app-config';
import { Analytics } from '@segment/analytics-node';

let analytics = null; // we need this to be available in global scope so we can initialize it once.

export const track = (event, errHandler) => {
  // this code only gets executed server side, so here we check to see if the
  // segment library has been initialized; if not we initialize it.
  if (analytics === null) {
    analytics = new Analytics({
      writeKey: appConfig.BROWSER.SEGMENT.WRITE_KEY,
      maxEventsInBatch: 1,
      flushInterval: 1,
    });
  }

  analytics.track(event, errHandler);
};
